import React from 'react';

export const areasOfExpertiseData = [
	{
		icon: '/images/icons/development-icon.svg',
		title: 'Custom Software Development',
		content: (
			<ul>
				<li>
					Web Applications
					<p className="pl-5">Frontend</p>
					<p className="pl-5">Backend</p>
				</li>
				<li>
					Mobile Applications
					<p className="pl-5">Native</p>
					<p className="pl-5">Cross-platform</p>
				</li>
			</ul>
		),
		url: 'development/',
	},
	{
		icon: '/images/icons/testing-icon.svg',
		title: 'Quality Assurance & Testing',
		content: (
			<ul>
				<li>Manual testing</li>
				<li>Automated testing</li>
				<li>Unit testing</li>
			</ul>
		),
		url: 'testing/',
	},
	{
		icon: '/images/icons/iot-icon.svg',
		title: 'Internet of Things (IoT)',
		content: (
			<ul>
				<li>IoT protocols & standards</li>
				<li>Hardware Design & Development</li>
			</ul>
		),
		url: 'iot/',
	},
	{
		icon: '/images/icons/integrations-icon.svg',
		title: 'Integrations',
		content: (
			<ul>
				<li>Systems integration </li>
				<li>Sensors integrations</li>
			</ul>
		),
		url: 'integrations/',
	},
	{
		icon: '/images/icons/design-icon.svg',
		title: 'UI/UX Design',
		content: (
			<ul>
				<li>Research</li>
				<li>Concept</li>
				<li>Software architecture</li>
				<li>UX design services</li>
			</ul>
		),
		url: 'design/',
	},
	{
		icon: '/images/icons/location-assets-icon.svg',
		title: 'Locations and asset tracking',
		content: (
			<ul>
				<li>Custom footfall analytics </li>
				<li>Custom asset tracking</li>
			</ul>
		),
		url: 'location-and-asset-tracking/',
	},
	{
		icon: '/images/icons/devops-icon.svg',
		title: 'DevOps',
		content: (
			<ul>
				<li>Support of software development process </li>
				<li>High grade SLAs</li>
			</ul>
		),
		url: 'devops/',
	},
	{
		icon: '/images/icons/ai.svg',
		title: 'Artificial Intelligence (AI)',
		content: (
			<ul>
				<li>Development and integration of AI solutions</li>
				<li>Machine Learning, NLP, Neural Networks</li>
				<li>AI innovations in IoT and data processing</li>
			</ul>
		),
		url: 'artificial-intelligence/',
	},
];
